const quickInsights = `
<p class="m-b-5">
  To get started, checkout some of our most popular insights 👉
</p>

<ul class="m-t-5 m-l-25 m-b-5">
  <li>
    <a href="#/dashboard/insights/admin-profit-and-cost?source=insightsTour">
      <u>Profit and cost analysis</u>
    </a>
  </li>
  <li>
    <a href="#/dashboard/insights/pub-this-month-profitability?source=insightsTour">
      <u>This month's Publisher profitability</u>
    </a>
  </li>
  <li>
    <a href="#/dashboard/insights/adjustments-this-month?source=insightsTour">
      <u>Adjustments this month</u>
    </a>
  </li>
  <li>
    <a href="#/dashboard/insights/target-profitability?source=insightsTour">
      <u>Target profitability</u>
    </a>
  </li>
</ul>

<p>
  <a href="https://cdn.ringba.com/tour/insights/quickinsightsresized.gif" target="_blank">
    <img border="0" alt="Quick Insights" src="https://cdn.ringba.com/tour/insights/quickinsightsresized.gif" width="100%" height="100%">
  </a>
</p>
`;

const quickInsightsStep = {
  target: '.quick-insights-btn',
  header: {
    title: '🌟 Quick Insights',
  },
  content: quickInsights,
  params: {
    placement: 'left'
  }
};


export default function getInsightTourSteps(showExport) {
  const startStepsFrom = 1;

  const steps = [
    {
      target: '.reporting-grid-data',
      header: {
        title: '🙋‍♀️ Welcome to Insights!',
      },
      content: 'This feature allows you to have a complete overview of your performance metrics, generate detailed reports and view call data broken down by: Campaign, Publisher, Target and many other dimensions.',
      params: {
        placement: 'bottom'
      }
    },
    {
      target: '.reporting-grid-data',
      header: {
        title: '📝 Overview',
      },
      content: `Insights consists of these major parts:
          <ol class="p-l-15">
            <li>Breakdown Levels</li>
            <li>Columns (Aggregate data)</li>
            <li>Filters</li>
            <li>Views</li>
            ${showExport ? `<li>Export</li>` : ''}
            <li>Insights visibility</li>
            <li>Quick Insights</li>
          </ol>
          <p>In this tour, we'll explore what each one does.</p>`,
      params: {
        placement: 'bottom'
      }
    },
    {
      target: '#level1',
      header: {
        title: '🔬 Breakdown Levels',
      },
      content: `Breakdown Levels allows you to segment your data based on a number of different parameters. There are no restrictions on the amount of Breakdown Levels you can apply.
          <p class="m-b-10 m-t-10">

            📓 Learn more: 

            <a href="https://support.ringba.com/en-us/article/insights-overview-1d5lv6w/?1587152465346#3-breakdown-levels" target="_blank">
              <u>Breakdown levels</u>
            </a>
          </p>
          <p>
            <a href="https://cdn.ringba.com/tour/insights/breakdownlevel.gif" target="_blank">
              <img border="0" alt="Breakdown animated gif" src="https://cdn.ringba.com/tour/insights/breakdownlevel.gif" width="100%" height="100%">
            </a>
          </p>
          `,
      params: {
        placement: 'auto'
      }
    },
    {
      target: '.ag-side-bar.ag-unselectable.ag-side-bar-right .ag-tool-panel-wrapper',
      header: {
        title: '🧾 Columns',
      },
      content: `Columns will contain aggregated data grouped by the call data selected on the Breakdown Levels. Tick the checkbox next to the column to display it on your report.
          <p class="m-b-10 m-t-10">

            📓 Learn more: 

            <a href="https://support.ringba.com/en-us/article/insights-overview-1d5lv6w/?1587152465346#3-columns" target="_blank">
              <u>Columns</u>
            </a>
          </p>

          <p>
            <a href="https://cdn.ringba.com/tour/insights/columnsnewresized.gif" target="_blank">
              <img border="0" alt="Columns animated gif" src="https://cdn.ringba.com/tour/insights/columnsnewresized.gif" width="100%" height="100%">
            </a>
          </p>
          `,
      params: {
        placement: 'auto-start'
      }
    },
    {
      target: 'insights-vue-container div.reporting-settings-container > div:nth-child(2) button',
      header: {
        title: '🔍 Filters',
      },
      content: `Filters are used to further refine your Insights data, helping you craft a report best suited to your specific needs.
          <p class="m-b-10 m-t-10">
            📓 Learn more: 
            <a href="https://support.ringba.com/en-us/article/insights-overview-1d5lv6w/?1587152465346#3-filters" target="_blank">
              <u>Filters</u>
            </a>
          </p>
          <p>
            <a href="https://cdn.ringba.com/tour/insights/filtersresized2.gif" target="_blank">
              <img border="0" alt="Filters animated gif" src="https://cdn.ringba.com/tour/insights/filtersresized2.gif" width="100%" height="100%">
            </a>
          </p>
          `,
      params: {
        placement: 'auto'
      }
    },
    {
      target: 'insights-vue-container .chart-selector',
      header: {
        title: '📊 Charting',
      },
      content: `You can view Insights data within three interactive visualizations: tables, bar charts and pie charts.
          <p class="m-b-10 m-t-10">
            📓 Learn more: 
            <a href="https://support.ringba.com/en-us/article/insights-overview-1d5lv6w/?1587152465346#3-views" target="_blank">
              <u>Types of views</u>
            </a>
          </p>
          <p>
            <a href="https://cdn.ringba.com/tour/insights/chartsnewresized.gif" target="_blank">
              <img border="0" alt="Chart animated gif" src="https://cdn.ringba.com/tour/insights/chartsnewresized.gif" width="100%" height="100%">
            </a>
          </p>
          `,
      params: {
        placement: 'auto'
      }
    },
    {
      target: 'insights-vue-container .export-csv-btn',
      header: {
        title: '📥 Export',
      },
      content: `It's possible to choose between exporting the Full Export with all data included, or simply Selected Columns.
          <p class="m-b-10 m-t-10">
            📓 Learn more: 
            <a href="https://support.ringba.com/en-us/article/insights-overview-1d5lv6w/?1587152465346#3-exporting-insights" target="_blank">
              <u>Export options</u>
            </a>
          </p>
          <p>
            <a href="https://cdn.ringba.com/tour/insights/exportresized.gif" target="_blank">
              <img border="0" alt="Export animated gif" src="https://cdn.ringba.com/tour/insights/exportresized.gif" width="100%" height="100%">
            </a>
          </p>
          `,
      params: {
        placement: 'auto'
      }
    },
    {
      target: '.saved-report-form',
      header: {
        title: '💾 Saving Reports',
      },
      content: `Insights Report visibility can be set to Personal or Shared. By setting to Personal, only you will be able to view the saved report. Alternatively, the Shared view will allow other account admins to see the report.
          <p class="m-b-10 m-t-10">
            📓 Learn more: 
            <a href="https://support.ringba.com/en-us/article/insights-overview-1d5lv6w/?1587152465346#3-saving-insights" target="_blank">
              <u>Save options</u>
            </a>
          </p>
          <p>
            <a href="https://cdn.ringba.com/tour/insights/Save4.gif" target="_blank">
              <img border="0" alt="Save animated gif" src="https://cdn.ringba.com/tour/insights/Save4.gif" width="100%" height="100%">
            </a>
          </p>

          `,
      params: {
        placement: 'right'
      }
    },
    quickInsightsStep
  ];

  showExport ? steps : steps.splice(6, 1);

  const totalSteps = steps.length - startStepsFrom - 1;

  return steps.map((step, index) => {
    let content = step.content;
    if (index > startStepsFrom) {
      content += `<p class="text-center m-t-5 f-s-11">Step ${index - startStepsFrom}/${totalSteps}</p`;
    }

    return {
      ...step,
      content
    };
  });
  
}